import React from 'react';

export function useScrollIntoView(focusRef: React.RefObject<HTMLElement>, selected: boolean) {
  // Scroll the list item into view after selecting new option on the map
  React.useLayoutEffect(() => {
    // setTimeout is required for it to work on mount of the Dialog
    setTimeout(() => {
      if (selected && focusRef && focusRef.current) {
        focusRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, 0);
  }, [selected]);
}
